import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';

@Component({
  selector: 'app-try-ademo',
  templateUrl: './try-ademo.component.html',
  styleUrls: ['./try-ademo.component.scss']
})
export class TryADemoComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('看看免费语法检查工具的实际应用-Trinka.ai');
    this.metaTagService.updateTag({ name: 'description', content: 'Trinka演示-Trinka是用于学术和技术写作的语法和语言校正的人工智能AI工具，能在文法、拼写、标点符号之上改善写作。免费使用！' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka.ai-人工智能语法检查工具' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka是学术和技术写作语法和语言校正工具，能发现其他工具找不出来的棘手错误。免费使用！' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://trinka.enago.cn/grammar-checker' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-cn' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://trinka.enago.cn/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/grammar-checker' });
    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/wisepop.js', function(){});
    }
  }

}
